/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Pricing_Faq_1_QInputs */

const en_mk_pricing_faq_1_q = /** @type {(inputs: Mk_Pricing_Faq_1_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why price per seat instead of per workspace?`)
};

const id_mk_pricing_faq_1_q = /** @type {(inputs: Mk_Pricing_Faq_1_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kenapa harganya per orang, bukan per workspace?`)
};

/**
* | output |
* | --- |
* | "Why price per seat instead of per workspace?" |
*
* @param {Mk_Pricing_Faq_1_QInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_pricing_faq_1_q = /** @type {((inputs?: Mk_Pricing_Faq_1_QInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Pricing_Faq_1_QInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_pricing_faq_1_q(inputs)
	return en_mk_pricing_faq_1_q(inputs)
});